import { render, staticRenderFns } from "./UserUpdatePassword.vue?vue&type=template&id=664e5cdc&"
import script from "./UserUpdatePassword.vue?vue&type=script&lang=js&"
export * from "./UserUpdatePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports